/**
 * 创建人：zll
 * 时间：2020-09-25
 * 描述：表格下拉排序功能（非点击表格表头排序）
 * 使用说明: 参考 sw-order 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input,Output,EventEmitter,AfterViewInit,HostListener, ElementRef, SimpleChanges} from '@angular/core';
declare var $: any;


/**
 * 表格下拉排序组件 sw-order
 */
@Component({
  selector: 'sw-order',
  templateUrl: './sw-order.component.html',
  styleUrls: ['./sw-order.component.css']
})
export class SwOrderComponent implements OnInit,AfterViewInit {
  /**
   * 打开下拉排序数据
   * @ignore
   */
  drownDown:boolean= false;

  /**
   * orderNames 下拉排序对应字段值（和表格表头排序对应的columnname相同） 数组
   * {id:"",text:""} 
   */
  @Input() orderNames: any = [];  

  /**
   * orderTypes 下拉排序对应的 升序降序数组 有默认值 
   * {id:"",text:""} 
   */
 orderTypes:any[] =[
    {id:"asc",text:"升序"},
    {id:"desc",text:"降序"}
  ] 

  /**
   * orderBy 下拉排序对应的选中数据 字符串 格式类型为 't.' + orderName + ' ' + orderType
   * t.role_name asc
   */
   orderBy:string = ""
   /**
   * defaultOrderBy 下拉排序对应的默认选中值 字符串 格式类型为 't.' + orderName + ' ' + orderType
   * 业务端传入
   * t.role_name asc
   */
  @Input() defaultOrderBy:string = ""
  /**
   * 选中排序数据
   */
  @Output() order =  new EventEmitter();
 
  selectName: string = ""  //选中对应的orderNames 下拉排序对应id字段值

  selectType: string = "desc"  //选中对应的orderTypes 下拉排序升序降序对应的id值

  /**
   * @ignore
   */
  constructor(private _elementRef: ElementRef) { }

  /**
   * @ignore
   */
  ngOnInit() {
  }

  /**
   * @ignore
   */
  ngAfterViewInit() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes['defaultOrderBy']['currentValue']){
       let name = this.defaultOrderBy.split(" ")[0].split(".")[1]
       let type = this.defaultOrderBy.split(" ")[1]
       this.selectName = name
       this.selectType = type
    }
  }
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const clickInside = this._elementRef.nativeElement.contains(targetElement)
    if(!clickInside) {
      this.drownDown = false
    }
    
  }
  /**
   * 打开筛选数据
   * @ignore
   */
  open() {
    this.drownDown = !this.drownDown;
  }

  /**
   * 选中数据
   * @param value 选中的id 
   * @ignore
   */
  isChecked(value) {
     return this.orderNames[value]
  }
  
  /**
   * 抛出点击name事件
   * @param value 
   * @ignore
   */
  clickName(value) {
    this.selectName = value
    let orderby = 't.'+this.selectName+" "+this.selectType
    if(this.selectName && this.selectType){
      this.order.emit(orderby)
      this.drownDown = false
    }
   
  }
   /**
   * 抛出点击type事件
   * @param value 
   * @ignore
   */
  clickType(value) {
   this.selectType = value
   let orderby = 't.'+this.selectName+" "+this.selectType
   if(this.selectName && this.selectType){
    this.order.emit(orderby)
    this.drownDown = false
   }
  }

}
